import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createfacilities, updatefacilities, getfacilities, deletefacilitiess } from '../../ReduxToolkit/Slice/Facilities/Facilites';
import JoditEditor from 'jodit-react';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';


function Facilites() {
  const dispatch = useDispatch();
  const { status, facilitiess } = useSelector((state) => state.facilities);
  const [Image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const closeButtonRef = useRef(null);
  const [isDescriptionValid, setIsDescriptionValid] = useState(true);
  // create
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!description) {
      setIsDescriptionValid(false);
      return;
    }
    setIsDescriptionValid(true);
    const formData = new FormData();
    formData.append('Image', Image === null ? "" : Image);
    formData.append('title', title);
    formData.append('description', description);
    dispatch(createfacilities(formData));
    setImage(null);
    setTitle("");
    setDescription("");
    closeButtonRef.current.click();

  };
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getfacilities())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (facilitiesid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Facilities?")
    if (Isconfirmed) {
      dispatch(deletefacilitiess(facilitiesid))
    };
  }
  // single data fetch
  const [updateButton, setupdateButton] = useState("d-none")
  const [SubmitButton, setSubmitButton] = useState("")
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selectefacilities = facilitiess.data.find(facilities => facilities._id === id);
    setTitle(selectefacilities.title);
    setImage(selectefacilities.Image);
    setDescription(selectefacilities.description);
    setSelectedId(id);
    if (selectefacilities) {
      setupdateButton("")
      setSubmitButton("d-none")
    }
    else { }
  };
  // update
  const handleEdit = () => {
    const formData = new FormData();
    formData.append('Image', Image === null ? "" : Image);
    formData.append('title', title);
    formData.append('description', description);
    dispatch(updatefacilities({ selectedId, formData }));
    setImage(null);
    setTitle("");
    setDescription("");
  }
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const columns = [
    { label: "Title", accessor: "title" },
    { label: "Description", accessor: "description" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },

];
  return (
    <>
      <div>
        <ToastContainer/>
        <div className='d-flex justify-content-between my-3'>
          <h3>Facilities</h3>
          <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  Facilities </button>
        </div>
       
        <CommanTable
                    columns={columns}
                    data={facilitiess.data || []}
                    status={status}
                    onDelete={handleDelete}
                    onEdit={handlid}
                    databstarget="#exampleModal"
                    model="modal"
                />
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload facilities
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleSubmit}>
              <div className="row">
                <div className="mb-3 col-lg-6">
                  <label htmlFor="title" className="form-label">
                    Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    required
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title"
                  />
                </div>
                <div className="mb-3 col-lg-6">
                  {/* <img src={thumbnail} className='img-fluid rounded' alt="" /> */}
                  <label htmlFor="Image" className="form-label">
                    Image
                  </label>
                  <input
                    type="file"
                    required
                    className="form-control"
                    id="thumbnail"
                    name="thumbnail"
                    // value={thumbnail}
                    onChange={(e) => setImage(e.target.files[0])}
                  />
                </div>
                <div className="mb-3 col-lg-12">
                  <label htmlFor="content" className="form-label">
                    description
                  </label>
                  <JoditEditor
                    required={true}
                    value={description}
                    tabIndex={1} // 
                    onBlur={newdescription => setDescription(newdescription)}
                    onChange={newdescription => { }}
                  />
                </div>
                <div className={`modal-footer ${SubmitButton}`}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  ref={closeButtonRef}
                >
                  Close
                </button>
                <button type="submit"  className={`btn btn-primary`}>
                  Upload
                </button>
              </div>
              </div>
              </form>
              

              <div className={`modal-footer ${updateButton}`}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" onClick={handleEdit} className={`btn btn-primary`} data-bs-dismiss="modal"  >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Facilites;
